import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 🔥 关键修复：用 render 函数替代 template + components（适配 runtime-only 版本）
new Vue({
  el: '#app',
  router,
  render: h => h(App) // 无需模板编译器，直接渲染 App 组件
})